import { createContext } from 'react';

import type { AnyRoute } from '@tanstack/react-router';

/**
 * The TanStack routes built from the shim route that renders the element. It holds two
 * routes for a trailing optional param. The value never changes, unlike TanStack's match ID.
 */
export const RouteContext = createContext<readonly AnyRoute[] | null>(null);
